var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.6 5.61952H9.9516L6.7332 8.94257C6.4989 9.18449 6.4989 9.5768 6.73305 9.81856C6.96735 10.0605 7.34745 10.0605 7.58175 9.81856L11.8242 5.438C11.8521 5.4092 11.877 5.37745 11.8989 5.34368C11.9089 5.32804 11.916 5.31116 11.9247 5.2949C11.9346 5.27569 11.946 5.25742 11.954 5.23713C11.9625 5.21622 11.9673 5.19454 11.9733 5.17285C11.9782 5.15566 11.9847 5.13925 11.9881 5.12159C11.9959 5.08132 12 5.04074 12 5.00001L11.9999 4.99862C11.9997 4.9585 11.9958 4.91823 11.9881 4.87874C11.9845 4.86016 11.9778 4.84296 11.9726 4.82469C11.9667 4.80409 11.9622 4.78318 11.9541 4.7632C11.9454 4.74167 11.9337 4.72216 11.9229 4.70187C11.9148 4.68669 11.9084 4.6712 11.8991 4.65665C11.8772 4.62242 11.852 4.59051 11.8239 4.56155L7.5816 0.181459C7.3473 -0.0604602 6.96735 -0.0604604 6.73305 0.181303C6.49875 0.423222 6.49875 0.815527 6.73305 1.0576L9.95145 4.3805H0.6C0.26865 4.3805 0 4.65789 0 5.00001C0 5.34213 0.26865 5.61952 0.6 5.61952Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.7b1965361ec300451e046a5762556e8f.svg";
export { ForwardRef as ReactComponent };